import React from 'react';
import { Heart, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../../context/SiteContentContext';

const MissionTeaser = () => {
  const { siteContent } = useSiteContent();
  const missionTeaser = siteContent?.missionTeaser || {};

  if (missionTeaser.visible === false) return null;

  return (
    <section className="py-14 sm:py-16 md:py-20 bg-slate-50">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="w-11 h-11 sm:w-12 sm:h-12 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-5">
            <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-rose-500" />
          </div>
          <span className="text-xs sm:text-sm font-medium text-slate-400 uppercase tracking-wider mb-3 sm:mb-4 block">
            {missionTeaser.label || 'Our Mission'}
          </span>
          <p className="text-base sm:text-lg md:text-xl text-slate-600 leading-relaxed mb-5 sm:mb-6">
            {missionTeaser.text || 'Quality English education that creates positive change.'}
          </p>
          <Link
            to="/about"
            className="inline-flex items-center text-sm font-medium text-slate-900 hover:text-slate-600 transition-colors py-2"
          >
            {missionTeaser.linkText || 'Learn more'}
            <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionTeaser;
